import {
  GET_VENDOR_DOWNLOAD_BOOKINGS,
  GET_VENDOR_DOWNLOAD_BOOKINGS_SUCCESS,
  GET_VENDOR_DOWNLOAD_BOOKINGS_ERROR,
  GET_VENDOR_DOWNLOAD_BOOKINGS_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadBookingsDump = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDOR_DOWNLOAD_BOOKINGS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_DOWNLOAD_BOOKINGS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_DOWNLOAD_BOOKINGS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_VENDOR_DOWNLOAD_BOOKINGS_EMPTY:
      state = {
        data: null,
        message: null,
        loading: false,
        success: false,
        error: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadBookingsDump;
